import { Suspense } from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { Section, SectionContent, SectionHeader } from "@impero-com/ui";
import { Spin } from "antd";

import { OAuthConnectionsTable } from "./OAuthConnectionsTable";

interface OAuthConnectionsSectionProps {
    userId: number;
}

/**
 * The OAuth clients connected to a user's account, with a way to revoke each of them. Shown to
 * the user on their profile and to organization admins on the user's page.
 */
export function OAuthConnectionsSection({
    userId,
}: OAuthConnectionsSectionProps) {
    const { t } = useTranslation();
    return (
        <Section>
            <SectionHeader
                level={4}
                titleLabel={t("OAuthConnections_Title")}
                subtitleLabel={t("OAuthConnections_Description")}
            />
            <SectionContent>
                <Suspense fallback={<Spin />}>
                    <OAuthConnectionsTable userId={userId} />
                </Suspense>
            </SectionContent>
        </Section>
    );
}
